import { BaseEdge, EdgeLabelRenderer, EdgeProps, getSmoothStepPath } from '@xyflow/react'
import { CrossIcon } from '@honestica/curecall-ui'
import { useChatbotFlow } from '../chatbot.provider'

export function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
  markerEnd,
  style,
}: EdgeProps) {
  const { onEdgesChange } = useChatbotFlow()

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  const handleDelete = (event: React.MouseEvent) => {
    event.stopPropagation()
    onEdgesChange([{ type: 'remove', id }])
  }

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
      {selected && (
        <EdgeLabelRenderer>
          <button
            type="button"
            onClick={handleDelete}
            className="c-absolute c-pointer-events-auto c-flex c-items-center c-justify-center c-w-5 c-h-5 c-rounded-full c-bg-white c-border c-border-primary-500 c-text-primary-500 hover:c-bg-primary-200"
            style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
            aria-label="Supprimer la connexion"
          >
            <CrossIcon className="c-w-3 c-h-3" />
          </button>
        </EdgeLabelRenderer>
      )}
    </>
  )
}
